module.exports = __webpack_public_path__ + "vassets/mobile/img/ad2.308c1e0e.jpeg";